export const PORTRAIT_BREAK_PX = 640
export const MOBILE_BREAK_PX = 640 // 640

export const MAIN_HEADER_HEIGHT_PX = 100;

/** How much room content should leave for the header 
 * (in case you ever need this to differ from actual height) */
export const MAIN_HEADER_VIRTUAL_HEIGHT_PX = 100;
